module.exports = __webpack_public_path__ + "images/hindsight_marketing.png";